export default {
  install(Vue, options) {
    let userAbilities = [];

    options.store.subscribe((mutation, state) => {
      if (mutation.type === 'auth/SET_ABILITIES') {
        userAbilities = state.auth.abilities;
      }
    });

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.hasAnyAbility = (...abilities) => abilities.some(
      (ability) => userAbilities.includes(ability.trim()),
    );

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.hasAllAbilities = (...abilities) => abilities.every(
      (ability) => userAbilities.includes(ability.trim()),
    );
  },
};
